<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-03 17:43:26
 * @LastEditTime: 2019-08-12 16:04:30
 * @LastEditors: Please set LastEditors
 -->
<template lang="html">
  <div class="content" v-loading.fullscreen.lock="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <search :params.sync="params" :showCharts="showCharts" :defaultDateRange="24" ref="search" />

    <div class="report-all-wrap">
      <h4 class="mb20">大盘报表</h4>
      <el-table
        :data="reportAll"
        style="width: 100%">
        <el-table-column
          fixed
          label="页面名称"
          width="200">
          大盘均值
        </el-table-column>
        <el-table-column
          prop="avg_fmp"
          label="首屏时间">
        </el-table-column>
        <el-table-column
          prop="avg_load"
          label="整屏时间">
        </el-table-column>
        <el-table-column
          prop="t_0_1000"
          label="1秒内量">
        </el-table-column>
        <el-table-column
          prop="t_0_1000_per"
          label="1秒内占比">
        </el-table-column>
        <el-table-column
          prop="t_0_2000"
          label="2秒内量">
        </el-table-column>
        <el-table-column
          prop="t_0_2000_per"
          label="2秒内占比">
        </el-table-column>
        <el-table-column
          prop="t_0_3000"
          label="3秒内量">
        </el-table-column>
        <el-table-column
          prop="t_0_3000_per"
          label="3秒内占比">
        </el-table-column>
        <el-table-column
          prop="total"
          label="大盘总量">
        </el-table-column>
        <el-table-column
          label="流量占比">
          100%
        </el-table-column>
        <el-table-column
          label="操作">
        </el-table-column>
      </el-table>
    </div>

    <div class="report-list-wrap">
      <div class="subType">
        <h4>页面报表</h4>
        <el-radio-group v-if="params[params.type]" v-model="subType" size="small" @change="subTypeChange">
          <el-radio-button label="appId" v-if="subTypeIsVisible('appId')">媒体</el-radio-button>
          <el-radio-button label="pageId" v-if="subTypeIsVisible('pageId')">页面</el-radio-button>
          <el-radio-button label="slotId" v-if="subTypeIsVisible('slotId')">广告位</el-radio-button>
        </el-radio-group>
        <el-button type="primary" size="small" @click="exportForm" style="margin-left: 10px;">导出报表</el-button>
      </div>
      <el-table
        :data="reportList"
        :row-class-name="tableRowClassName"
        :default-sort = "{prop: 'avg_ready', order: 'descending'}">
        <el-table-column
          fixed
          prop="key"
          :label="keyName"
          width="200">
        </el-table-column>
        <el-table-column
          prop="avg_fmp"
          label="首屏时间"
          sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.avg_fmp >= scope.row.avg_load" class="c-danger"><b>{{ scope.row.avg_fmp }}</b></span>
            <span v-else-if="scope.row.avg_fmp > 1500" class="c-warning">{{ scope.row.avg_fmp }}</span>
            <span v-else>{{ scope.row.avg_fmp }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="avg_load"
          label="整屏时间"
          sortable>
          <template slot-scope="scope">
            <span>{{ scope.row.avg_load }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="t_0_1000"
          label="1秒内量">
        </el-table-column>
        <el-table-column
          prop="t_0_1000_per"
          label="1秒内占比">
        </el-table-column>
        <el-table-column
          prop="t_0_2000"
          label="2秒内量">
        </el-table-column>
        <el-table-column
          prop="t_0_2000_per"
          label="2秒内占比">
        </el-table-column>
        <el-table-column
          prop="t_0_3000"
          label="3秒内量">
        </el-table-column>
        <el-table-column
          prop="t_0_3000_per"
          label="3秒内占比">
        </el-table-column>
        <el-table-column
          prop="count"
          label="页面数据量"
          sortable>
        </el-table-column>
        <el-table-column
          prop="count_per"
          label="流量占比">
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <div @click.stop="showUrl(scope.row)"><a>查看页面</a></div>
            <div @click.stop="rowClick(scope.row)"><a>多维度分析</a></div>
            <!-- <div @click.stop="lighthouse(scope.row)"><a>lighthouse</a></div> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="LightHouse"
      :visible.sync="iframeVisible"
      :fullscreen="true">
      <iframe :srcdoc="iframeDoc" frameborder="0" width="100%" :height="iframeHeight"></iframe>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import qs from "qs";

import search from '../../components/search';
import tool from '../../../../utils/tool.js';

export default {
  components: {
    search
  },
  data() {
    return {
      loading: false,

      subType: '',

      params: {},
      reportAll: [],
      reportList: [],

      allAvgFp: 0,
      allAvgFmp: 0,
      allAvgLoad: 0,

      iframeVisible: false,
      iframeDoc: '',
      iframeHeight: window.innerHeight - 54 - 60 - 10
    }
  },
  computed: {
    keyName: function() {
      const type = this.subType || this.params.type;
      return type === 'appId' ? '媒体ID' : type === 'pageId' ? '页面名称' : type === 'slotId' ? '广告位ID' : '';
    }
  },
  watch: {
    'params'() {
      const { type } = this.params;
      if (this.params[type]) {
        this.subType = type === 'appId' ? 'pageId' : type === 'pageId' ? 'appId' : type === 'slotId' ? 'pageId' : ''
      } else {
        this.subType = type
      }

    }
  },
  methods: {
    async showCharts() {
      this.loading = true;
      await this.fetchAll();
      await this.fetchList();
      this.loading = false;
    },

    fetchAll() {
      const { clientType, dateRange, type } = this.params;
      const query = {
        client: clientType,
        match: JSON.stringify({ [type]: this.params[type] }),
        dateRange
      };

      return axios
        .get(`/reportFormLoad/all?${qs.stringify(query)}`)
        .then(response => {
          const { data } = response.data;


          let tmpData = this.convertDataToTable(data.fmpTime);
          let total = response.data.total;

          let tableTimes = this.generateTableTime([
              { from: 0, to: 1000},
              { from: 0, to: 2000},
              { from: 0, to: 3000}
            ], tmpData, total);

          this.reportAll = [Object.assign({
            'total': total,
            'avg_fp': data.avg_fp,
            'avg_fmp': data.avg_fmp,
            'avg_load': data.avg_load,
          }, tableTimes)];

          this.allAvgFp = data.avg_fp;
          this.allAvgFmp = data.avg_fmp;
          this.allAvgLoad = data.avg_load;
        })
        .catch(error => {
          console.log(error);
        });
    },

    fetchList() {
      const { clientType, dateRange, type } = this.params;
      const query = {
        client: clientType,
        match: JSON.stringify({ [type]: this.params[type] }),
        dateRange,
        subType: this.subType
      };

      return axios
        .get(`/reportFormLoad/list?${qs.stringify(query)}`)
        .then(response => {
          const { data } = response.data;
          const total = response.data.total;

          this.reportList = data.map(item => {
            item.fmpTime = this.convertDataToTable(item.fmpTime);
            const count = item.doc_count;
            const tmpLoad = item.fmpTime;

            let tableTimes = this.generateTableTime([
              { from: 0, to: 1000},
              { from: 0, to: 2000},
              { from: 0, to: 3000}
            ], tmpLoad, count);

            let tmpItem = {
              'key': item.key,
              'count': count,
              'total': total,
              'avg_fp': item.avg_fp,
              'avg_fmp': item.avg_fmp,
              'avg_load': item.avg_load,
              'count_per': (count / total * 100).toFixed(2) + '%'
            }

            tmpItem = Object.assign({}, tmpItem, tableTimes);

            return tmpItem;
          });

        })
        .catch(error => {
          console.log(error);
        });
    },

    convertDataToTable(originData) {
      let resultData = {};

      originData.forEach(item => {
        resultData[item.key] = item.doc_count;
      });

      return resultData;
    },

    // 生成报表时间统计
    generateTableTime(rangeTimes, fmpTime, count) {
      let tableTimes = {};

      rangeTimes.forEach(item => {
        let key = `${item.from}_${item.to}`;
        tableTimes[`t_${key}`] = fmpTime[key];
        tableTimes[`t_${key}_per`] = (fmpTime[key] / count * 100).toFixed(2) + '%';
      });

      return tableTimes;
    },

    // 表格样式
    tableRowClassName({row, rowIndex}) {
      if (row.count / row.total < 0.01) {
        return 'light-row'
      }
      return '';
    },

    getUrl(row) {
      const { clientType, dateRange } = this.params;
      const query = {
        client: clientType,
        match: JSON.stringify({ pageId: row.key }),
        dateRange
      };
      return axios.get(`/reportFormLoad/findUrl?${qs.stringify(query)}`);
    },
    showUrl(row) {
      this.loading = true;
      this.getUrl(row).then(res => {
        this.loading = false;
        window.open(res.data.data, '_blank');
      })
    },
    lighthouse(row) {
      this.loading = true;
      this.getUrl(row).then(res_url => {
        axios.get(`/reportFormLoad/runLighthouse?url=${encodeURIComponent(res_url.data.data)}`).then(res_html => {
          this.loading = false;
          this.iframeDoc = res_html.data.data;
          this.iframeVisible = true;
        })
      })
    },

    rowClick(row) {
      const { appId, pageId } = this.params;
      if (!pageId) {
        this.$refs.search.setPageId(row.key);
      } else if (!appId) {
        this.$refs.search.setAppId(row.key);
      }
    },

    subTypeIsVisible(subType) {
      return this.params[this.params.type] && this.params.type !== subType;
    },

    subTypeChange(subType) {
      this.showCharts();
    },

    exportForm() {
      const config = [{
        name: 'key',
        title: '名称'
      }, {
        name: 'avg_fmp',
        title: '首屏时间'
      }, {
        name: 'avg_load',
        title: '整屏时间'
      }, {
        name: 't_0_1000',
        title: '1秒内量'
      }, {
        name: 't_0_1000_per',
        title: '1秒内占比'
      }, {
        name: 't_0_2000',
        title: '2秒内量'
      }, {
        name: 't_0_2000_per',
        title: '2秒内占比'
      }, {
        name: 't_0_3000',
        title: '3秒内量'
      }, {
        name: 't_0_3000_per',
        title: '3秒内占比'
      }, {
        name: 'count',
        title: '页面数据量'
      }, {
        name: 'count_per',
        title: '流量占比'
      }];
      const listData = this.reportList;
      const excelName = 'report-perf';

      const params = {
        config,
        listData,
        excelName
      }

      tool.downloadExcel(params);
    }
  }
};
</script>

<style lang="less">

.light-row {
  color: #ccc;
}
.content {
  padding: 30px;
}
.report-all-wrap {
  margin-top: 30px;
}
.report-list-wrap {
  margin-top: 30px;
}
.mb20 {
  margin-bottom: 20px;
}
.c-danger {
  color: #F56C6C;
}
.c-warning {
  color: #E6A23C;
}
.link{
  word-break: break-all;
}
tr{
  cursor: pointer;
}
.subType{
  margin-bottom: 20px;
  &::after{
    clear: both;
    display: block;
    content: '';
  }
  h4{
    float: left;
    line-height: 32px;
    margin-right: 20px;
  }
  .el-radio-group{
    float: left;
  }
}
</style>
